export default () => ({
  channels: [],
  users: [],
  userChannels: [],
  messages: [],
  isTyping: false,
  pageSize: 20,
  searchTerm: '',
  token: '',
  pageSizeUser: 20,
  searchTermUser: '',
  tokenUser: '',
  isChannelChecked: false,
  isChannelNotSaved: false,
  isUserChecked: false,
  requests: []
})



// WEBPACK FOOTER //
// ./src/store/modules/chat/state.js